


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class DoKoStackCards extends Vue {
  @Prop({
    type: String,
    default: "#ff6c6c",
  })
  private backgroundColor!: string;

  @Prop({
    type: Number,
    default: 110 / 735,
  })
  private scale!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private rotate!: number;

  get transformText() {
    return `translate(${this.x} ${this.y}) rotate(${this.rotate}) scale(${this.scale})`;
  }
}
